import { handleActions } from 'redux-actions';
import {
  updateModule,
  fetchModuleDataSuccess,
  fetchModuleConfigSuccess,
} from '../actions/modules';
import omit from 'lodash.omit';

const defaultState = {};

export default handleActions<any, any>(
  {
    [fetchModuleDataSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: omit(action.payload, ['entities']),
    }),
    [updateModule.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleData: {
          ...state[action.payload.id].moduleData,
          ...action.payload.moduleData,
        },
        moduleMeta: {
          ...state[action.payload.id].moduleMeta,
          ...action.payload.moduleMeta,
        },
      },
    }),
    [fetchModuleConfigSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleConfig: action.payload.config,
      },
    }),
  },
  defaultState
);
